let userEvent = false;
let allowAutomation = false;
let pageLoadGracePeriod = true;

setTimeout(() => pageLoadGracePeriod = false, 1000);

['click', 'touchstart', 'submit', 'keydown'].forEach(evt => {
    window.addEventListener(evt, () => {
        userEvent = true;
        allowAutomation = true;
        setTimeout(() => userEvent = false, 250);
        setTimeout(() => allowAutomation = false, 2000);
    }, true);
});

const originalFetch = window.fetch;
window.fetch = function (...args) {
    const url = args[0];
    const isCartEndpoint = typeof url === 'string' &&
        ['/cart/add.js', '/cart/update.js', '/cart/change.js'].some(path => url.includes(path));

    if (isCartEndpoint && !userEvent && !allowAutomation && !pageLoadGracePeriod) {
        // Allow requests from cartx-related functions (BOGO sync, etc.)
        const stack = new Error().stack || '';
        const isFromCartxFunctions = stack.includes('cartx') || 
                                      stack.includes('syncUnlockedGiftsWithCart') || 
                                      stack.includes('reload_cartx') ||
                                      stack.includes('fetchCart');
        
        if (!isFromCartxFunctions) {
            console.warn('blocked non-user cart request:', url);
            return Promise.resolve(new Response('{}', { status: 403, statusText: 'Blocked' }));
        }
    }

    return originalFetch.apply(this, args);
};